<div
  class="search"
  [ngClass]="{ hidden: !active }">
  <div
    #origin="matAutocompleteOrigin"
    #searchOrigin
    class="search__container"
    matAutocompleteOrigin
    [ngClass]="{ hidden: !complete }">
    <div
      class="search__input"
      role="button"
      tabindex="-1"
      [ngClass]="{ 'search__input--focused': activeType === userSearchKind.FindSearch }"
      (click)="onInputClick(userSearchKind.FindSearch, false)"
      (keydown.tab)="onInputClick(userSearchKind.FindSearch, false)"
      (keypress.tab)="onInputClick(userSearchKind.FindSearch, false)"
      (keyup.tab)="onInputClick(userSearchKind.FindSearch, false)">
      <label for="find">
        <sharry-icon
          svgClass="search__icon"
          [name]="icons[userSearchKind.FindSearch]"></sharry-icon>
        {{ 'shop.header.find-label' | i18next }}</label
      >
      <div>
        <input
          #findInput
          matInput
          type="text"
          [formControl]="searchGroup.controls.find_search"
          [matAutocompleteConnectedTo]="origin"
          [matAutocomplete]="findauto"
          [placeholder]="'shop.header.find' | i18next" />
        <sharry-icon
          matSuffix
          name="x-circle-fill"
          svgClass="search__icon--show touchable"
          [ngClass]="{
            'search__icon--hidden':
              !searchGroup?.value?.find_search?.length && !$any(searchGroup?.value?.find_search)?.hashtagName,
          }"
          (click)="searchGroup.get(userSearchKind.FindSearch).setValue(''); clearFind.emit()"></sharry-icon>
      </div>
    </div>
    <div
      class="search__input"
      role="button"
      tabindex="-1"
      [ngClass]="{ 'search__input--focused': activeType === userSearchKind.WhereSearch }"
      (click)="onInputClick(userSearchKind.WhereSearch, false)"
      (keydown.tab)="onInputClick(userSearchKind.WhereSearch, false)"
      (keypress.tab)="onInputClick(userSearchKind.WhereSearch, false)"
      (keyup.tab)="onInputClick(userSearchKind.WhereSearch, false)">
      <label for="where">
        <sharry-icon
          svgClass="search__icon"
          [name]="icons[userSearchKind.WhereSearch]"></sharry-icon>
        {{ 'shop.header.where-label' | i18next }}</label
      >
      <div>
        <input
          #whereInput
          matInput
          type="text"
          [formControl]="searchGroup.controls.where_search"
          [matAutocompleteConnectedTo]="origin"
          [matAutocomplete]="whereauto"
          [placeholder]="'shop.header.where' | i18next" />
        <sharry-icon
          matSuffix
          name="x-circle-fill"
          svgClass="search__icon--show touchable"
          [ngClass]="{
            'search__icon--hidden':
              !searchGroup?.value?.where_search?.length && !$any(searchGroup?.value?.where_search)?.title,
          }"
          (click)="resetWhere(); clearWhere.emit()"></sharry-icon>
      </div>
    </div>
    <div
      class="search__input"
      role="button"
      tabindex="-1"
      [ngClass]="{ 'search__input--focused': activeType === userSearchKind.WhenSearch }"
      (click)="onInputClick(userSearchKind.WhenSearch, false)"
      (keydown.tab)="onInputClick(userSearchKind.WhenSearch, false)"
      (keypress.tab)="onInputClick(userSearchKind.WhenSearch, false)"
      (keyup.tab)="onInputClick(userSearchKind.WhenSearch, false)">
      <label for="when">
        <sharry-icon
          svgClass="search__icon"
          [name]="icons[userSearchKind.WhenSearch]"></sharry-icon>
        {{ 'shop.header.when-label' | i18next }}</label
      >
      <div>
        <input
          #whenInput
          autocomplete="off"
          readonly
          type="text"
          [formControl]="searchGroup.controls.when_search"
          [placeholder]="'shop.header.when' | i18next" />
        <sharry-icon
          matSuffix
          name="x-circle-fill"
          svgClass="search__icon--show touchable"
          [ngClass]="{ 'search__icon--hidden': !searchGroup?.value?.when_search?.length }"
          (click)="onRemoveDate(); clearWhen.emit()"></sharry-icon>
      </div>
    </div>
    <div
      class="search__input"
      [ngClass]="{ 'search__input--focused': activeType === userSearchKind.WhenSearch }">
      <button
        class="header-search__links__search sharry-big rounded"
        color="rainbow"
        mat-flat-button
        (click)="onSearch()">
        {{ 'header-search.search' | i18next }}
      </button>
    </div>
  </div>
</div>
<mat-autocomplete
  #findauto="matAutocomplete"
  class="dialog__autocomplete"
  [displayWith]="displayWith"
  [hideSingleSelectionIndicator]="true">
  @if (findAutocompleteVisible) {
    <p class="semibold dialog__autocomplete__group-title">{{ 'header-search.near' | i18next }}</p>
    <mat-option
      class="dialog__autocomplete__location"
      [value]="''"
      (click)="onLocationSearch()">
      <img
        src="https://media.sharry.land/app/images/img-meraviglie_vicino.svg"
        width="40"
        height="40"
        style="border-color: #e79db7"
        alt="meraviglie vicino" />
      <p class="medium">{{ 'prefix-search.location' | i18next }}</p>
    </mat-option>
  }
  @for (option of findAutocompleteOptions$ | async; track option; let i = $index) {
    @if (findAutocompleteVisible) {
      @if (i === 0) {
        <p class="semibold dialog__autocomplete__group-title">{{ 'header-search.contents' | i18next }}</p>
      }
      <mat-option
        [value]="option"
        (click)="onAutocomplete(option)">
        @if (option.__typename && option.__typename !== 'Hashtag' && option.__typename !== 'User') {
          <img
            width="36"
            height="40"
            alt="tipologia"
            [src]="
              'https://media.sharry.land/app/images/families/pin-' +
              (option.__typename === 'Sharry' ? option.sharrySelection : option.__typename?.toLowerCase()) +
              ($any(option).soldBySharryland ? '--sold-by-sharryland' : '') +
              '.webp'
            " />
        }
        @if (option.__typename && option.__typename === 'User') {
          <img
            width="36"
            height="40"
            alt="tipologia"
            [src]="
              'https://media.sharry.land/app/images/families/pin-user' +
              (option.sharrylandPartner ? '-gold' : option?.role === 'trusted_user' ? '-trusted' : '') +
              '.webp'
            " />
        }

        @if (option.__typename === 'Hashtag') {
          <sharry-icon
            name="hash"
            type="phosphor"
            svgClass="svg-icon"></sharry-icon>
        }
        {{ $any(option).title || $any(option).fullname || $any(option).hashtagName }}
      </mat-option>
    }
  }
</mat-autocomplete>
<mat-autocomplete
  #whereauto="matAutocomplete"
  class="dialog__autocomplete"
  [displayWith]="displayWith"
  [hideSingleSelectionIndicator]="true">
  @if (whereAutocompleteVisible) {
    <p class="semibold dialog__autocomplete__group-title">{{ 'header-search.near' | i18next }}</p>
    <mat-option
      class="dialog__autocomplete__location"
      [value]="''"
      (click)="onLocationSearch()">
      <img
        src="https://media.sharry.land/app/images/img-meraviglie_vicino.svg"
        width="40"
        height="40"
        style="border-color: #e79db7"
        alt="meraviglie vicino" />
      <p class="medium">{{ 'prefix-search.location' | i18next }}</p>
    </mat-option>
  }
  @for (option of whereAutocompleteOptions$ | async; track option.id; let i = $index) {
    @if (whereAutocompleteVisible) {
      @if (i === 0) {
        <p class="semibold dialog__autocomplete__group-title">{{ 'header-search.contents' | i18next }}</p>
      }
      <mat-option
        [value]="option"
        (click)="onAutocomplete(option)">
        <sharry-icon
          name="map-pin-line"
          type="phosphor"
          svgClass="svg-icon"></sharry-icon>
        {{ option.title }}
      </mat-option>
    }
  }
</mat-autocomplete>
<ng-template #templatePortalContent>
  <div class="dialog is-not-mobile">
    <ng-container [ngTemplateOutlet]="searchDesktop"></ng-container>
  </div>
  <div class="dialog-mobile is-mobile">
    <ng-container [ngTemplateOutlet]="searchMobile"></ng-container>
  </div>
</ng-template>

<ng-template #searchDesktop>
  <div
    class="dialog__structure"
    [ngClass]="{ 'dialog__structure--ipad': mobileIpad }">
    <ng-container
      [ngTemplateOutletContext]="{
        results: userSearches$ | async,
      }"
      [ngTemplateOutlet]="lastResearch"></ng-container>
    <div
      class="dialog__structure__search"
      id="dialog__structure__search">
      @if (activeType === userSearchKind.FindSearch) {
        <ng-container
          [ngTemplateOutlet]="boxes"
          [ngTemplateOutletContext]="{
            boxes: (categories$ | async),
            filter: activeType,
            title: 'header-search.categories',
          }"></ng-container>
        <ng-container
          [ngTemplateOutlet]="boxes"
          [ngTemplateOutletContext]="{
            boxes: sharrySearchTypes,
            filter: activeType,
            backgrounds: true,
            title: 'header-search.sharry-types',
          }"></ng-container>
        <ng-container
          [ngTemplateOutlet]="boxes"
          [ngTemplateOutletContext]="{
            boxes: searchTypes,
            filter: activeType,
            backgrounds: true,
            title: 'header-search.types',
          }"></ng-container>
      }
      @if (activeType === userSearchKind.WhereSearch) {
        <ng-container
          [ngTemplateOutlet]="boxes"
          [ngTemplateOutletContext]="{
            boxes: regions,
            filter: activeType,
            title: 'header-search.regions',
          }"></ng-container>
      }
      @if (activeType === userSearchKind.WhenSearch) {
        <ng-container
          [ngTemplateOutlet]="boxes"
          [ngTemplateOutletContext]="{
            boxes: seasons,
            filter: activeType,
            title: 'header-search.select-period',
          }"></ng-container>
        <ng-container [ngTemplateOutlet]="calendar"></ng-container>
      }
    </div>
  </div>
</ng-template>

<ng-template #searchMobile>
  <div class="dialog-mobile__header">
    <sharry-icon
      svgClass="dialog-mobile__header__icon"
      [name]="isFocusMode ? 'caret-left' : 'x'"
      (click)="onClose(isFocusMode)"></sharry-icon>
  </div>
  <div
    class="dialog-mobile__body"
    [ngClass]="{ 'dialog-mobile__body--capacitor': usingCapacitor }">
    <div class="dialog-mobile__body__near">
      <p class="semibold header-search__autocomplete-mobile__group-title">{{ 'header-search.near' | i18next }}</p>
      <ng-container [ngTemplateOutlet]="near"></ng-container>
    </div>
    <mat-accordion
      displayMode="flat"
      [hideToggle]="true">
      @for (type of types; track type) {
        <mat-expansion-panel
          class="sharry-flat-panel dialog-mobile__container"
          role="button"
          [@.disabled]="true"
          [disabled]="activeType === type"
          [expanded]="activeType === type"
          [ngClass]="{
            'dialog-mobile__container--opened': activeType === type,
            'dialog-mobile__container--focused':
              (activeType === userSearchKind.FindSearch || activeType === userSearchKind.WhereSearch) &&
              activeType === type &&
              isFocusMode,
            hidden:
              (activeType === userSearchKind.FindSearch || activeType === userSearchKind.WhereSearch) &&
              activeType !== type &&
              isFocusMode,
          }"
          (click)="onChooseFilter(type)"
          (keypress)="onChooseFilter(type)"
          (keydown)="onChooseFilter(type)"
          (keyup)="onChooseFilter(type)">
          <mat-expansion-panel-header
            class="dialog-mobile__container__header"
            [ngClass]="{ 'dialog-mobile__container__header--active': activeType === type }">
            <sharry-icon
              svgClass="svg-icon"
              [name]="icons[type]"></sharry-icon>
            <p>
              {{ 'shop.header.' + type + '-label' | i18next }}
              @if (activeType !== type) {
                <small [class.semibold]="searchGroup?.get(type)?.value?.length">
                  @if (searchGroup?.get(type)?.value?.length) {
                    {{ searchGroup?.get(type)?.value }}
                  } @else {
                    {{ 'shop.header.' + type | i18next }}
                  }
                </small>
              }
            </p>
          </mat-expansion-panel-header>
          @if (
            (activeType === userSearchKind.FindSearch || activeType === userSearchKind.WhereSearch) &&
            activeType === type
          ) {
            <div class="dialog-mobile__container__bar">
              <input
                matInput
                sharryFormScroll
                [formControl]="searchGroup.controls[activeType]"
                [placeholder]="
                  (activeType === userSearchKind.FindSearch ? 'shop.header.find' : 'shop.header.where') | i18next
                "
                (focus)="onFocus()" />
              @if (isFocusMode) {
                <button
                  matIconSuffix
                  mat-icon-button
                  color="secondary"
                  class="sharry-medium"
                  (click)="onRemove(activeType)">
                  @if (searchGroup?.get(activeType)?.value?.length) {
                    <sharry-icon
                      matSuffix
                      name="x-circle-fill"
                      svgClass="search__icon--show touchable"></sharry-icon>
                  }
                </button>
              }
              @if (!isFocusMode) {
                <button
                  matIconSuffix
                  mat-icon-button
                  color="secondary"
                  class="sharry-medium"
                  (click)="isFocusMode = !isFocusMode">
                  <sharry-icon name="magnifying-glass"></sharry-icon>
                </button>
              }
            </div>
            <div [ngClass]="{ hidden: !isFocusMode }">
              @if (activeType === userSearchKind.FindSearch) {
                <ng-container
                  [ngTemplateOutlet]="autocompleteMobile"
                  [ngTemplateOutletContext]="{
                    searchType: activeType,
                    results: (findAutocompleteOptions$ | async),
                  }"></ng-container>
              }
              @if (activeType === userSearchKind.WhereSearch) {
                <ng-container
                  [ngTemplateOutlet]="autocompleteMobile"
                  [ngTemplateOutletContext]="{
                    searchType: activeType,
                    results: (whereAutocompleteOptions$ | async),
                  }"></ng-container>
              }
            </div>
            <div [ngClass]="{ hidden: isFocusMode }">
              @if (activeType === userSearchKind.FindSearch) {
                <ng-container
                  [ngTemplateOutlet]="boxes"
                  [ngTemplateOutletContext]="{
                    boxes: (categories$ | async),
                    filter: activeType,
                    title: 'header-search.categories',
                  }"></ng-container>
                <ng-container
                  [ngTemplateOutlet]="boxes"
                  [ngTemplateOutletContext]="{
                    boxes: sharrySearchTypes,
                    filter: activeType,
                    backgrounds: true,
                    title: 'header-search.sharry-types',
                  }"></ng-container>
                <ng-container
                  [ngTemplateOutlet]="boxes"
                  [ngTemplateOutletContext]="{
                    boxes: searchTypes,
                    filter: activeType,
                    backgrounds: true,
                    title: 'header-search.types',
                  }"></ng-container>
              }
              @if (activeType === userSearchKind.WhereSearch) {
                <ng-container
                  [ngTemplateOutlet]="boxes"
                  [ngTemplateOutletContext]="{
                    boxes: regions,
                    filter: activeType,
                    title: 'header-search.regions',
                  }"></ng-container>
              }
            </div>
          }
          @if (activeType === userSearchKind.WhenSearch && activeType === type) {
            <ng-container
              [ngTemplateOutlet]="boxes"
              [ngTemplateOutletContext]="{
                boxes: seasons,
                filter: activeType,
                title: 'header-search.select-period',
              }"></ng-container>
            <ng-container [ngTemplateOutlet]="calendar"></ng-container>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="dialog-mobile__footer">
    <button
      class="reset-button"
      (click)="onReset()">
      {{ 'header-search.clear' | i18next }}
    </button>
    <button
      class="rounded sharry-medium"
      color="rainbow"
      mat-flat-button
      (click)="onSearch()">
      {{ 'header-search.search' | i18next }}
    </button>
  </div>
</ng-template>

<ng-template #calendar>
  <div class="dialog__form">
    <small>{{ 'header-search.select-dates' | i18next }}</small>
    <mat-form-field class="no-error">
      <mat-date-range-input
        [min]="minDate"
        [rangePicker]="picker">
        <input
          matStartDate
          readonly
          [placeholder]="'header-search.select-dates.start' | i18next"
          [(ngModel)]="startDate"
          (ngModelChange)="onDateChange()" />
        <input
          matEndDate
          readonly
          [placeholder]="'header-search.select-dates.end' | i18next"
          [(ngModel)]="endDate"
          (ngModelChange)="onDateChange()" />
      </mat-date-range-input>
      @if (searchGroup.get(userSearchKind.WhenSearch)?.value?.length) {
        <button
          matIconSuffix
          mat-icon-button
          color="secondary"
          class="sharry-medium"
          (click)="onRemoveDate()">
          @if (searchGroup?.get(activeType)?.value?.length) {
            <sharry-icon
              matSuffix
              name="x-circle-fill"
              svgClass="search__icon--show touchable"></sharry-icon>
          }
        </button>
      } @else {
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker">
          <sharry-icon
            name="calendar-blank"
            matDatepickerToggleIcon></sharry-icon>
        </mat-datepicker-toggle>
      }
      <mat-date-range-picker
        #picker
        (closed)="setEndDateIfStart()"></mat-date-range-picker>
    </mat-form-field>
  </div>
</ng-template>

<ng-template
  #boxes
  let-backgrounds="backgrounds"
  let-boxes="boxes"
  let-filter="filter"
  let-title="title">
  <div
    class="dialog__form"
    [ngClass]="{ 'dialog__form--no-margin-top': filter === userSearchKind.WhenSearch }">
    @if (!!title) {
      <small>{{ title | i18next }}</small>
    }
    <div
      class="dialog__structure__boxes"
      [ngClass]="{ 'dialog__structure__boxes--where': filter !== userSearchKind.FindSearch }">
      @for (box of boxes; track box) {
        <button
          [ngClass]="{
            'dialog__structure__boxes--active': box.active,
            'dialog__structure__boxes--backgrounds': backgrounds,
            'dialog__structure__boxes--zones': filter === userSearchKind.WhereSearch,
            'dialog__structure__boxes--hidden': box.hidden,
          }"
          [ngStyle]="{ 'background-image': 'url(' + box?.previewImage?.url + ')' }"
          (click)="onBoxClick(box, filter); isMobile() && $event.stopPropagation()">
          @if (filter === userSearchKind.WhenSearch) {
            <sharry-icon
              name="calendar-blank"
              svgClass="svg-icon"></sharry-icon>
          }
          @if (filter === userSearchKind.WhereSearch) {
            <img
              class="img-where"
              alt=""
              [src]="'https://media.sharry.land/app/images/travel/place/' + box.normalizedName + '.webp'" />
          }
          <span
            sharryEllipsisTooltip
            [ngClass]="{ 'span-find': filter === userSearchKind.FindSearch }"
            >{{ box.name | i18next }}</span
          >
        </button>
      }
    </div>
  </div>
</ng-template>
<ng-template
  #lastResearch
  let-results="results">
  <div class="dialog__structure__search">
    <ng-container [ngTemplateOutlet]="near"></ng-container>
    @if (results?.length) {
      <small class="bold">{{ 'header-search.recent-searches' | i18next }}</small>
      @for (result of results; track result) {
        <div class="dialog__structure__results">
          <sharry-icon
            name="arrow-bend-down-right"
            svgClass="svg-icon"></sharry-icon>
          <a
            sharryEllipsisTooltip="1"
            class="internal-link regular"
            [matTooltip]="result.searchString"
            [href]="result.searchUrl"
            (click)="
              onClose(false, result.searchUrl);
              result.searchUrl === previousSearchResult ? $event.preventDefault() : null
            "
            >{{ result.searchString }}</a
          >
        </div>
      }
      <div class="dialog__structure__results">
        <sharry-icon
          name="eraser"
          svgClass="svg-icon svg-icon--eraser"></sharry-icon>
        <button
          class="sharry-simple"
          (click)="cleanSearchResult()">
          {{ 'header-search.erase-searches' | i18next }}
        </button>
      </div>
    }
    <!--    <small class="bold dialog__structure__search&#45;&#45;distance-top">{{
      'header-search.suggested-searches' | i18next
    }}</small>
    @for (result of suggestedSearches$ | async; track result) {
      <div class="dialog__structure__results">
        <sharry-icon
          name="arrow-bend-down-right"
          svgClass="svg-icon"></sharry-icon>
        <a
          sharryEllipsisTooltip="1"
          class="internal-link regular"
          [matTooltip]="result.searchString"
          [href]="result.searchUrl"
          (click)="
            onClose(false, result.searchUrl); result.searchUrl === previousSearchResult ? $event.preventDefault() : null
          "
          >{{ result.searchString }}</a
        >
      </div>
    }-->
    <button
      class="reset-button"
      (click)="onReset()">
      {{ 'header-search.clear' | i18next }}
    </button>
  </div>
</ng-template>

<ng-template
  #autocompleteMobile
  let-options="results"
  let-searchType="searchType"
  [typeToken]="autocompleteToken">
  <div class="header-search__autocomplete-mobile">
    @if (options?.length) {
      <mat-selection-list
        [hideSingleSelectionIndicator]="true"
        [multiple]="false">
        @for (option of options; track option; let i = $index) {
          @if (i === 0) {
            <p class="semibold header-search__autocomplete-mobile__group-title">
              {{ 'header-search.contents' | i18next }}
            </p>
          }
          <mat-list-option
            [value]="option"
            (click)="onAutocomplete(option)">
            @if (searchType === userSearchKind.WhereSearch) {
              <sharry-icon
                name="map-pin-line"
                type="phosphor"
                svgClass="svg-icon"></sharry-icon>
              {{ option.title }}
            } @else {
              @if (option.__typename && option.__typename !== 'Hashtag' && option.__typename !== 'User') {
                <img
                  width="36"
                  height="40"
                  alt="tipologia"
                  [src]="
                    'https://media.sharry.land/app/images/families/pin-' +
                    (option.__typename === 'Sharry' ? option.sharrySelection : option.__typename?.toLowerCase()) +
                    ($any(option).soldBySharryland ? '--sold-by-sharryland' : '') +
                    '.webp'
                  " />
              }
              @if (option.__typename && option.__typename === 'User') {
                <img
                  width="36"
                  height="40"
                  alt="tipologia"
                  [src]="
                    'https://media.sharry.land/app/images/families/pin-user' +
                    (option.sharrylandPartner ? '-gold' : option?.role === 'trusted_user' ? '-trusted' : '') +
                    '.webp'
                  " />
              }

              @if (option.__typename === 'Hashtag') {
                <sharry-icon
                  name="hash"
                  type="phosphor"
                  svgClass="svg-icon"></sharry-icon>
              }
              <span sharryEllipsisTooltip>
                {{ $any(option).title || $any(option).fullname || $any(option).hashtagName }}</span
              >
            }
          </mat-list-option>
        }
      </mat-selection-list>
    }
  </div>
  @if (!options?.length) {
    <div class="dialog__structure__search">
      @if (userSearches$ | async; as userSearches) {
        @if (userSearches.length) {
          <small class="semibold header-search__autocomplete-mobile__group-title">{{
            'header-search.recent-searches' | i18next
          }}</small>

          <div class="dialog__structure__search dialog__structure__search--last-search">
            @for (result of userSearches; track result.id) {
              <div class="dialog__structure__results">
                <sharry-icon
                  name="arrow-bend-down-right"
                  svgClass="svg-icon"></sharry-icon>
                <a
                  sharryEllipsisTooltip="1"
                  class="internal-link regular"
                  [matTooltip]="result.searchString"
                  [href]="result.searchUrl"
                  >{{ result.searchString }}</a
                >
              </div>
            }
            <div class="dialog__structure__results">
              <sharry-icon
                name="eraser"
                svgClass="svg-icon svg-icon--eraser"></sharry-icon>
              <button
                class="sharry-simple"
                (click)="cleanSearchResult()">
                {{ 'header-search.erase-searches' | i18next }}
              </button>
            </div>
          </div>
        }
      }

      <!--      <small class="bold dialog__structure__search&#45;&#45;distance-top">{{
        'header-search.suggested-searches' | i18next
      }}</small>
      @for (result of suggestedSearches$ | async; track result) {
        <div class="dialog__structure__results">
          <sharry-icon
            name="arrow-bend-down-right"
            svgClass="svg-icon"></sharry-icon>
          <a
            sharryEllipsisTooltip="1"
            class="internal-link regular"
            [matTooltip]="result.searchString"
            [href]="result.searchUrl"
            (click)="onClose()"
            >{{ result.searchString }}</a
          >
        </div>
      }-->
    </div>
  }
</ng-template>

<ng-template #near>
  <div
    class="header-search__autocomplete-mobile__location"
    (click)="onLocationSearch()">
    <img
      alt="meraviglie vicino"
      height="40"
      src="https://media.sharry.land/app/images/img-meraviglie_vicino.svg"
      style="border-color: #e79db7"
      width="40" />
    <p class="medium">{{ 'prefix-search.location' | i18next }}</p>
  </div>
</ng-template>
